"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    "emptyDay-monday": {
        en: "Free Monday",
        es: "Lunes Libre",
    },
    "emptyDay-tuesday": {
        en: "Free Tuesday",
        es: "Martes Libre",
    },
    "emptyDay-wednesday": {
        en: "Free Wednesday",
        es: "Miercoles Libre",
    },
    "emptyDay-thursday": {
        en: "Free Thursday",
        es: "Jueves Libre",
    },
    "emptyDay-friday": {
        en: "Free Friday",
        es: "Viernes Libre",
    },
    "emptyDay-saturday": {
        en: "Free Saturday",
        es: "Sabado Libre",
    },
    "emptyDay-sunday": {
        en: "Free Sunday",
        es: "Domingo Libre",
    },
    monday: {
        en: "Mon",
        es: "Lun",
    },
    tuesday: {
        en: "Tue",
        es: "Mar",
    },
    wednesday: {
        en: "Wed",
        es: "Mie",
    },
    thursday: {
        en: "Thu",
        es: "Jue",
    },
    friday: {
        en: "Fri",
        es: "Vi",
    },
    saturday: {
        en: "Sat",
        es: "Sab",
    },
    sunday: {
        en: "Sun",
        es: "Dom",
    },
    loadRoutes: {
        en: "Load Routes",
        es: "Cargar Rutas",
    },
    minutes: {
        en: "Minutes",
        es: "Minutos",
    },
    hours: {
        en: "Hours",
        es: "Horas",
    },
    mondayFull: {
        en: "Monday",
        es: "Lunes",
    },
    tuesdayFull: {
        en: "Tuesday",
        es: "Martes",
    },
    wednesdayFull: {
        en: "Wednesday",
        es: "Miércoles",
    },
    thursdayFull: {
        en: "Thursday",
        es: "Jueves",
    },
    fridayFull: {
        en: "Friday",
        es: "Viernes",
    },
    saturdayFull: {
        en: "Saturday",
        es: "Sábado",
    },
    sundayFull: {
        en: "Sunday",
        es: "Domingo",
    },
};
exports.default = translations;
